module.exports = __webpack_public_path__ + "static/media/x-circle.1e82afdc.svg";